import React, { useState, useEffect } from "react";
import { Zap, Download, Smartphone } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "../components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/dropdown-menu";

const styles = {
  header: {
    position: "fixed",
    top: "1rem",
    left: "5%",
    width: "90%",
    backgroundColor: "#fff",
    boxShadow: "0 6px 6px rgba(0, 0, 0, 0.06)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.75rem 1rem",
    borderRadius: "1.6rem",
    border: "1px solid #cccccc",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  logoImage: {
    width: "32px",
    height: "32px",
    objectFit: "contain",
  },
  logoText: {
    fontSize: "1.25rem",
    fontFamily: "Lexend, sans-serif",
    color: "#3E3E3E",
    fontWeight: "bold",
    letterSpacing: 1.2,
    whiteSpace: "nowrap",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
};

const FixedHeader = ({ xpPoints }) => {
  const [homeLink, setHomeLink] = useState("/");
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmCampaign = searchParams.get("utm_campaign");

    const betaParams = new URLSearchParams();
    if (utmSource) betaParams.append("utm_source", utmSource);
    if (utmMedium) betaParams.append("utm_medium", utmMedium);
    if (utmCampaign) betaParams.append("utm_campaign", utmCampaign);

    const params = betaParams.toString();
    const newBetaLink = params ? `/?${params}` : "/";
    setHomeLink(newBetaLink);
  }, [location.search]);

  return (
    <header style={styles.header}>
      <div style={styles.logoContainer}>
        <Link
          to={homeLink}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img
            src={`${process.env.PUBLIC_URL}/PrepAiro.png`}
            alt="PrepAiro Logo"
            style={styles.logoImage}
          />
        </Link>
        <Link
          to={homeLink}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span style={styles.logoText}>PrepAiro</span>
        </Link>
      </div>

      <div style={styles.rightSection}>
        {/* DOWNLOAD APP BUTTON */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="xp"
              size="sm"
              className="font-display hidden sm:flex items-center gap-2"
            >
              <Download className="w-5 h-5" />
              <span className="hidden md:inline">Download App</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-64 p-4" align="end">
            <DropdownMenuLabel className="flex items-center text-md font-semibold p-0 mb-3">
              <Smartphone className="mr-2 h-5 w-5 text-primary" />
              Download PrepAiro
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <div className="flex flex-col items-center text-center mt-3">
              <div className="p-2 bg-muted rounded-md inline-block mb-3">
                <img
                  src={`${process.env.PUBLIC_URL}/go.prepairo.ai.site.png`}
                  alt="QR code to download PrepAiro app"
                  width={150}
                  height={150}
                  className="rounded-sm"
                />
              </div>
              <h3 className="text-sm font-medium mb-1 text-foreground">
                Scan with your phone
              </h3>
              <p className="text-xs text-muted-foreground px-2">
                The QR code will take you to the correct app store for your
                device.
              </p>
            </div>
          </DropdownMenuContent>
        </DropdownMenu>

        {/* XP POINTS */}
        <Button
          variant="xp"
          size="sm"
          className="group flex items-center gap-1 w-20"
        >
          <Zap className="w-5 h-5 group-hover:animate-bounce" />
          <span className="md:hidden text-sm font-medium">{xpPoints}</span>
          <span className="hidden md:inline">{xpPoints} XP</span>
        </Button>
      </div>
    </header>
  );
};

export default FixedHeader;
